/**
 * Admin › Roadmap (v7 Part E). Every screen that is not built yet — off the menus (rule 4) — grouped by the release that
 * brings it, with what it will hold. The data is the registry itself; nothing invented.
 */
import { NAV_SCREENS, RELEASES, menuLabel, releaseOf } from '@rtcom/domain';
import { Page } from '../shell/AppShell';
import { Panel, PanelHeader } from '../ui/primitives';
import { isBuilt } from './implementedScreens';

export function RoadmapScreen() {
  const planned = NAV_SCREENS.filter((s) => !s.hidden && !isBuilt(s.id));
  const built = NAV_SCREENS.filter((s) => !s.hidden && isBuilt(s.id)).length;
  const groups = RELEASES.map((r) => ({ r, screens: planned.filter((s) => releaseOf(s.id) === r.id) })).filter((g) => g.screens.length);
  return (
    <Page title="Roadmap" subtitle={`${built} screens are in use. ${planned.length} more come in the releases below; until then they are not in the menus.`}
      footer="From the navigation registry, the same entries the menus read">
      <div className="flex flex-col gap-4">
        {groups.map(({ r, screens }) => (
          <Panel key={r.id}>
            <PanelHeader title={`${r.id === 'NEXT' ? 'Later' : r.id} · ${r.label}`} note={`${screens.length} screen${screens.length === 1 ? '' : 's'}`} />
            <ul className="divide-y divide-line">
              {screens.map((s) => (
                <li key={s.id} id={s.id} className="grid gap-1 px-4 py-3 md:grid-cols-[14rem_minmax(0,1fr)]">
                  <div className="font-medium text-ink">{menuLabel(s)}</div>
                  <div className="text-small text-ink-muted">
                    <p>{s.description.replace(/\s*\((?:BRIEF|EPIC|CD-|D\d)[^)]*\)/g, '')}</p>
                    {s.plan?.items.length ? <p className="mt-0.5"><span className="font-medium text-ink">Will hold: </span>{s.plan.items.join(' · ')}</p> : null}
                  </div>
                </li>))}
            </ul>
          </Panel>))}
      </div>
    </Page>
  );
}
